import { Icon } from '@zillow/constellation-10';
import { IconUserAddFilled } from '@zillow/constellation-icons';

import ListingActivationTerm from '../../../../components/ListingActivationTerms';

import ConnectedModuleCard from '../../../ConnectedModuleCard';
import EmptyState from '../../../EmptyState';
import ApplicationShareLinks from '../ApplicationShareLinks';

import type { ApplicationsSummary } from '../../interfaces';

type Props = {
  applicationsSummary?: ApplicationsSummary;
};

const EmptyApplicationsCard = ({ applicationsSummary }: Props) => (
  <ConnectedModuleCard data-testid="EmptyApplicationsCard">
    <EmptyState
      useCard={false}
      align="left"
      headingLevel={4}
      icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconUserAddFilled />} />}
      heading="No new applications"
      body="You can invite renters to apply or wait for renters to apply via your listing on Zillow, Trulia, and HotPads. Applications received in the last 90 days will appear here."
      actions={
        <ApplicationShareLinks
          isTertiaryButtonStyling={false}
          hideViewOlderApplications={false}
          applicationsSummary={applicationsSummary}
        />
      }
    />
    <ListingActivationTerm actionText="By enabling or sharing applications" />
  </ConnectedModuleCard>
);

export default EmptyApplicationsCard;
